import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function NewsletterThirtyThree() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter June 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            New York Allocates $1 Billion to Advance Clean Energy and
            Infrastructure.
          </title>
          <meta
            name="description"
            content="New York State has allocated over $1 billion in its FY2026 budget to accelerate decarbonization and promote environmental sustainability."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          New York Allocates $1 Billion to Advance Clean Energy and
          Infrastructure.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/june_2025_1.webp")}
            alt="New York Allocates $1 Billion to Advance Clean Energy and Infrastructure."
            loading="lazy"
          />
        </figure>
        <p>
          New York State has allocated over $1 billion in its FY2026 budget to
          accelerate decarbonization and promote environmental sustainability.
          The Sustainable Future Program includes $450 million for
          energy-efficient building retrofits and clean heating technologies,
          such as heat pumps, and $250 million to expand electric vehicle
          infrastructure and electrify school bus fleets. Additionally, $200
          million is dedicated to developing thermal energy networks at public
          institutions, including SUNY campuses, to modernize energy
          infrastructure and reduce emissions.
        </p>
        <p>
          The budget also invests $425 million in the Environmental Protection
          Fund (EPF), focusing on habitat preservation, farmland protection, and
          climate change mitigation. This includes $90 million for sustainable
          agriculture and farmland conservation, $20 million to improve
          farmworker housing, and $10 million for dairy modernization. These
          measures aim to strengthen the state's agricultural sector and promote
          environmental resilience.
        </p>
        <p>
          These investments are designed to reduce greenhouse gas emissions,
          create clean energy jobs, and enhance the state's infrastructure. By
          focusing on building decarbonization, renewable energy expansion, and
          environmental conservation, New York aims to transition to a more
          sustainable and resilient economy. The FY2026 budget reflects a
          comprehensive approach to addressing climate change and supporting
          communities across the state.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To align with New York’s climate push, companies should explore
            anchor roles in district thermal networks, embed adaptive
            electrification into asset planning, and prequalify for public
            private retrofit pilots. Rather than chasing compliance, firms can
            position themselves as infrastructure co developers by tapping into
            grid edge innovations, integrated mobility systems, and workforce
            reskilling. It is less about reaction and more about redesigning
            operations as flexible nodes in a decentralized low carbon urban
            ecosystem.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EBA Proposes Proportional ESG Reporting Framework for Banks.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/images/june_2025_2.webp")}
              alt="EBA Proposes Proportional ESG Reporting Framework for Banks."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The European Banking Authority (EBA) has initiated a public
          consultation to amend ESG disclosure requirements under the CRR3
          framework, aiming to simplify compliance while enhancing transparency
          and consistency. This initiative supports the European Commission’s
          omnibus proposal to cut reporting costs and streamline sustainability
          reporting. The revised framework proposes a proportionate approach
          based on institution size, complexity, and listing status, offering
          simplified requirements for smaller and non-listed banks. For large
          listed banks, no new ESG obligations are introduced.
        </p>
        <p>
          The proposed amendments expand ESG risk disclosure requirements to all
          institutions and refine the reporting of equity exposures and shadow
          banking activities. The EBA is also incorporating updated statistical
          codes (NACE) and adjusting the Green Asset Ratio (GAR) templates to
          ensure permanent alignment with the EU Taxonomy Regulation. To ease
          adoption, the EBA proposes transitional provisions and supervisory
          flexibility, including a “no-action” letter advising regulators not to
          prioritise enforcement of specific ESG disclosure templates during the
          transition phase.
        </p>
        <p>
          The consultation is open until August 22, 2025. Institutions and
          stakeholders are encouraged to provide feedback on the proposed
          changes to ensure a balanced and effective ESG reporting framework
          across the European banking sector.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Banks should embed ESG intelligence into core strategy by leveraging
            predictive analytics to anticipate regulatory shifts. They should
            build adaptive data systems that unify climate, risk, and financial
            metrics. Cultivating cross functional ESG fluency empowers proactive
            governance, stakeholder trust, and long term value creation in a
            rapidly evolving sustainability landscape.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          India Introduces Climate Finance Taxonomy to Guide Sustainable
          Investments.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/june_2025_3.webp")}
            alt="India Introduces Climate Finance Taxonomy to Guide Sustainable Investments."
            loading="lazy"
          />
        </figure>
        <p>
          India has released a draft Climate Finance Taxonomy to identify and
          classify economic activities that align with the country’s climate and
          development objectives. Developed by the Ministry of Finance, the
          framework aims to support investors and financial institutions in
          channelling funds toward projects that contribute to emissions
          reduction, climate adaptation, or the transition of high-emission
          sectors. It also seeks to limit the risk of greenwashing and improve
          transparency in sustainable finance.
        </p>
        <p>
          The taxonomy outlines two core categories: climate-supportive and
          transition-supportive activities. It covers priority sectors such as
          power, mobility, buildings, agriculture, and heavy industries
          including steel and cement. The classification begins with qualitative
          criteria and will gradually incorporate measurable thresholds. India’s
          current energy mix includes 47.4 percent from non-fossil sources, and
          the taxonomy is expected to help scale investments in clean energy,
          energy efficiency, and resilient infrastructure.
        </p>
        <p>
          The framework recognises the varied capacities across industries and
          includes tailored provisions for small and medium enterprises and
          agriculture. It adopts a phased and adaptive structure, designed to
          evolve with emerging technologies, data availability, and policy
          shifts. This approach is intended to help public and private investors
          identify credible opportunities that support India's climate goals and
          long-term development plans.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The taxonomy will give the industry a uniform reference for
            identifying climate-aligned investments, reducing uncertainty in
            project classification and reporting. By standardising definitions
            across sectors, it will improve access to green capital,
            particularly from global sources seeking clarity on environmental
            impact. This structure also encourages long-term planning in
            emission-intensive sectors by recognizing transitional pathways,
            making it easier to justify investments in low-carbon technologies
            that may not yet meet strict benchmarks.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU and UK Set to Link Carbon Markets in Push for Unified Climate and
          Trade Policy.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/june_2025_4.webp")}
            alt="EU and UK Set to Link Carbon Markets in Push for Unified Climate and Trade Policy."
            loading="lazy"
          />
        </figure>
        <p>
          The European Union and United Kingdom have formally committed to
          exploring the linkage of their Emissions Trading Systems (ETS), aiming
          to streamline carbon pricing and strengthen climate action across both
          economies. The move could align regulatory frameworks, enhance market
          liquidity, and eliminate duplication, particularly as both regions
          roll out Carbon Border Adjustment Mechanisms (CBAM) – the EU’s by 2026
          and the UK’s by 2027 – which tax imports based on embedded emissions.
        </p>
        <p>
          The proposed linkage also holds strategic trade significance. A
          unified carbon market would allow mutual CBAM exemptions, reducing
          frictions for cross-border industries while maintaining environmental
          integrity. Both jurisdictions recognize the importance of pricing
          carbon consistently to avoid market distortions and carbon leakage,
          and to drive clean investment at scale. The effort signals renewed
          transnational cooperation on climate policy in the wake of Brexit,
          aligning long-term net-zero ambitions.
        </p>
        <p>
          In the latest joint declaration, both sides agreed to begin technical
          talks, supported by data-sharing commitments to ensure transparent
          emissions accounting and comparable carbon pricing. This includes
          alignment on ETS design elements such as cap trajectories, allowance
          allocation, monitoring, and verification systems. The success of these
          data-driven negotiations will determine how closely the two systems
          can integrate and whether this linkage becomes a template for wider
          international carbon market cooperation.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The evolving linkage of carbon markets and the implementation of
            CBAM present an opportunity to future-proof global trade. Businesses
            that invest in cleaner production, accurate emissions tracking, and
            alignment with international carbon standards can reduce compliance
            risks and gain a competitive edge. Embracing low-carbon strategies
            not only ensures smoother market access but also strengthens
            long-term resilience and brand credibility.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          NGFS Unveils Short-Term Climate Scenarios to Assess Immediate
          Financial Risks.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/june_2025_5.webp")}
            alt="NGFS Unveils Short-Term Climate Scenarios to Assess Immediate Financial Risks."
            loading="lazy"
          />
        </figure>

        <p>
          The Network for Greening the Financial System (NGFS) has released its
          inaugural set of short-term climate scenarios, offering a framework to
          evaluate the near-term impacts of climate change and related policies
          on economic and financial stability. These scenarios, spanning a
          five-year horizon, are designed to assist central banks and financial
          supervisors in stress-testing and risk assessment exercises. They
          incorporate detailed sectoral analyses and macroeconomic variables,
          capturing the interplay between climate policies, extreme weather
          events, and economic trends.
        </p>
        <p>
          The NGFS outlines four distinct scenarios: "Disasters and Policy
          Stagnation" focuses solely on physical risks from extreme weather
          events; "Highway to Paris" and "Sudden Wake-Up Call" examine orderly
          and abrupt transition risks, respectively; and "Diverging Realities"
          combines both physical and transition risks, highlighting the
          complexities of uneven climate policy implementations across regions.
          These scenarios reveal potential GDP losses ranging from 6% to 12.5%
          in affected regions, emphasizing the significant economic
          repercussions of climate-related events.
        </p>
        <p>
          By providing granular data and modeling compound climate events, the
          NGFS aims to enhance the financial sector's preparedness for imminent
          climate risks. These scenarios serve as critical tools for
          policymakers and financial institutions to navigate the challenges
          posed by climate change, ensuring informed decision-making and
          resilience in the face of environmental uncertainties.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The release of NGFS short-term climate scenarios equips financial
            institutions with a forward-looking lens to identify near-term
            systemic vulnerabilities. It enables stress-testing under realistic,
            policy-linked disruptions, fostering sharper alignment between
            climate risk and capital allocation. This initiative also
            strengthens the credibility of climate disclosures and enhances
            cross-border comparability, ultimately embedding climate foresight
            into supervisory frameworks and accelerating the financial sector’s
            adaptive capacity in a fragmented, fast-evolving risk landscape.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default NewsletterThirtyThree;
